import React from 'react'
import { formatNumber, percentageFormat } from '../../../../../Utils/utils';

interface SecondCardImproveModalityProps {
    selectedModality: any;
    isInitialModality?: boolean;
}

const SecondCardImproveModality = ({ selectedModality, isInitialModality }: SecondCardImproveModalityProps) => {
  const respuestaMacro = isInitialModality === false 
  ? selectedModality && selectedModality.respuestaMacro
    ? selectedModality.respuestaMacro
    : null
  : selectedModality && selectedModality.respuestaMacroInicial
    ? selectedModality.respuestaMacroInicial
    : null;

  return (
          <div className="card-verify">
        <div className="card-verify__rows">
          {respuestaMacro && (
            <div>
              <div className="card-verify__quote">Cesión Comisión</div>
              <div className="card-verify__data">
                {(selectedModality.mejoraParcial &&
                  selectedModality.mejoraParcial.cesionComision) ||
                  "0"}
                %
              </div>
            </div>
          )}
          {respuestaMacro && (
            <div>
              <div className="card-verify__quote">TIR(%)</div>
              <div className="card-verify__data">
                {percentageFormat(respuestaMacro.tir) || '--'}
              </div>
            </div>
          )}
          {respuestaMacro && respuestaMacro.van && (
            <div>
              <div className="card-verify__quote">VAN</div>
              <div className="card-verify__data">
                {respuestaMacro.van || '--'}
              </div>
            </div>
          )}
        </div>
        <div className="card-verify__rows-line"></div>
        {respuestaMacro && (
          <div className="card-verify__rows">
            <div>
              <div className="card-verify__quote">Renta Vitalicia</div>
              <div className="card-verify__data">
                {formatNumber.new(respuestaMacro.primaPensionRv) || '--'}
              </div>
            </div>
            <div>
              <div className="card-verify__quote">Renta Temporal</div>
              <div className="card-verify__data">
                {formatNumber.new(respuestaMacro.primaPensionRt) || '--'}
              </div>
            </div>
          </div>
        )}
      </div>
  )
}

export default SecondCardImproveModality